var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"dashboard-wrapper"},[_c('div',{staticClass:"dashboard"},[_c('HeaderTitle'),_c('KpiCards'),_c('div',{staticClass:"main-content"},[_c('LeftPanel',{staticClass:"panel-left"}),_c('CenterPanel',{staticClass:"panel-center"}),_c('RightPanel',{staticClass:"panel-right"})],1)],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }